<template>
    <div>
        <div v-if="status == 0">
            Mengambil data pembayaran, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data pembayaran.
        </div>
        <div v-else>
            Invoice <strong>{{ data.no_faktur }}</strong><br />
            Customer: {{ data.customer_name }} ({{ data.customer_phone }})
            <b-table bordered hover show-empty no-local-sorting
                :items="items"
                :fields="fields"
                responsive class="mt-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada data pembayaran.
                </template>
                <template v-slot:cell(created_at)="row">
                    {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                    <div class="small text-muted">
                        oleh <strong>{{ row.item.created_by }}</strong>
                    </div>
                </template>
                <template v-slot:cell(type)="row">
                    <b-badge v-if="row.item.type == 1" variant="dark">PEMBAYARAN</b-badge>
                    <b-badge v-else-if="row.item.type == 2" variant="warning">ALOKASI RETUR</b-badge>
                </template>
                <template v-slot:cell(amount)="row">
                    Rp. {{ $helper.formatThousand(row.item.amount) }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            status: 0, // 0: loading, 1: success, -1: fail
            isSubmitting: false,

            data: {},

            fields: [
                { key: "created_at", label: "Tgl. Pembayaran", sortable: true },
                { key: "amount", label: "Jumlah", sortable: true },
                { key: "note", label: "Catatan", sortable: true },
            ],

            items: [],
            
            sortBy: null,
            sortDesc: false,

        }
    },
    props: {
        invoiceId: { type: Number, required: true }
    },
    methods: {

        init() {

            this.status = 0

            this.getItems()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            this.$axios.get("invoice/payments/" + this.invoiceId + param).then(res => {

                let data = res.data.data
                this.data = data.invoice
                this.items = data.payments

                this.status = 1

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.status = -1
            })
        }

    },
    created() {
        this.init()
    }
}
</script>
